module.exports = "/_next/static/images/certificate-c1ebfff6757fdeb88601c0d6ddd19ded.svg";